export default __webpack_public_path__ + "static/wilson-3e18d8f5fb8ad51d1983e91d425ee789.jpg";